import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from '@material-ui/core'
import { FormLoader } from '../../Loader/FormLoader'
import LabelImportantIcon from '@material-ui/icons/LabelImportant'
import SubdirectoryArrowRightIcon from '@material-ui/icons/SubdirectoryArrowRight'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import 'moment/locale/ar-ly'
import Moment from 'react-moment'
import { viewCodeStyles } from './Styles'
import { useStyles } from '../Styles'
import { getStatusIcon } from '../../../utils/helpers'
import { SingleCodeConsumer } from '../../../context/SingleCodeContext'
import codeStatus from '../../../configurations/code-status'

const CodeDetails = ({ code, type, getCodeData, requesterTaxpayer, ownerTaxpayer, status, locale, reuse, getCurrentCodeDataFromListing }) => {
  const classes = viewCodeStyles()
  const codeClasses = useStyles()
  const [isMounted, setIsMounted] = React.useState(false)
  const intl = useIntl()
  React.useEffect(() => {
      if (!!getCodeData && !!code && !!type) {
        if (!!['Approved'].includes(status?.toString()) || !!reuse) {
          getCodeData(type, code, requesterTaxpayer, ownerTaxpayer, status, !!reuse)
        } else {
          if (getCurrentCodeDataFromListing) {
            getCurrentCodeDataFromListing()
          }
        }
      }
      setIsMounted(true)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  React.useEffect(() => {
      if (!!isMounted && !!getCodeData && !!code && !!type) {
        if (!!['Approved'].includes(status?.toString()) || !!reuse) {
          getCodeData(type, code, requesterTaxpayer, ownerTaxpayer, status, !!reuse)
        } else {
          if (getCurrentCodeDataFromListing) {
            getCurrentCodeDataFromListing()
          }
        }
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [code, type])

  const getCodeItemData = (key, value, isAttributes) => {
    if (!!isAttributes) {
      let attributes = JSON.parse(value)
      return !!Object.keys(attributes || {}).length ? <div className={classes.attributeWrapper}>
        {Object.keys(attributes || {})?.map((attrKey, index) => (
          <div className={classes.attribute} key={index}>
            <span>{attrKey} :</span> {attributes[attrKey]}
          </div>
        ))}
      </div> : ''
    }

    if (!!key) {
      switch (key) {
        case 'activeFrom':
        case 'activeTo':
        case 'created_at':
        case 'updated_at':
          return <Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                         format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment>

        case 'category':
          return Object.keys(value || {})?.map((catLevel, index) => (
            !!value[catLevel]?.name &&
            <div key={index}
                 className={classes.category + ' ' + catLevel}>
              {catLevel !== 'level1' &&
              <SubdirectoryArrowRightIcon
                className={locale === 'ar' ? 'flip-direction' : ''}/>}{locale === 'ar' ? value[catLevel]?.nameAr || value[catLevel]?.name : value[catLevel]?.name}
            </div>
          )) || ''

        case 'active':
          return <span
            className={codeClasses.status + (!!value ? ' active' : ' not-active')}>{!!value ? intl.formatMessage({ id: 'Fields.label.view.codeActive.true' }) : intl.formatMessage({ id: 'Fields.label.view.codeActive.false' })}</span>

        case 'status':
          let valueArr = codeStatus?.filter((item) => item?.key?.toString().toLowerCase() === value?.toString()?.toLowerCase()) || []
          return !!valueArr && !!valueArr.length &&
            <div className={codeClasses.statusWrapper + ` ${valueArr[0]['key']?.toString().toLowerCase()}`}>
              {getStatusIcon(valueArr[0]['key'])}
              <span>{valueArr[0][`name_${locale}`]}</span>
            </div>
        default:
          return value

      }
    } else {
      return ''
    }
  }
  return (
    <SingleCodeConsumer>
      {({ currentCodeData, currentCodeLoading }) => (
        <>
          <div className={classes.RequestDataWrapper + (!!reuse ? ' reuse' : '')}>
            {!!currentCodeLoading && <FormLoader loading={true}/>}
            {!!currentCodeData && !!Object.keys(currentCodeData).length &&
            <div className={classes.RequestDataContainer}>
              {Object.keys(currentCodeData || {})?.map((groupKey, index) => (
                !!Object.keys(currentCodeData[groupKey] || {})?.length &&
                <Accordion defaultExpanded={true} key={index}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography className={classes.RequestHeading}><LabelImportantIcon/><FormattedMessage
                      id={`Code.group.title.${groupKey}`}/></Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className={classes.RequestInfoWrapper}>
                      {Object.keys(currentCodeData[groupKey] || {})?.map((itemKey, itemIndex) => (
                        !['nameAr'].includes(itemKey) && !!currentCodeData[groupKey][itemKey] &&
                        <React.Fragment key={itemIndex}>
                          <Grid item xs={12} sm={6} md={6} className={classes.infoItemWrapper}>
                            <Grid item xs={12} sm={4} className={classes.infoItemLabel}>
                              {groupKey === 'attributes' ? itemKey
                                : <FormattedMessage id={`Fields.label.view.Code.${itemKey}`}/>
                              }
                            </Grid>
                            <Grid item xs={12} sm={8} className={classes.infoItemValue}>
                              {getCodeItemData(itemKey, currentCodeData[groupKey][itemKey], groupKey === 'attributes')}
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      ))}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}

            </div>
            }
          </div>
        </>
      )}
    </SingleCodeConsumer>
  )
}

export default CodeDetails
